import { gql } from "@apollo/client";

export const ChangePasswordMutation = gql`
  mutation ChangePassword(
    $previousPassword: String!
    $region: AWSRegions!
    $newPassword: String!
    $username: String!
  ) {
    changePassword(
      previousPassword: $previousPassword
      region: $region
      newPassword: $newPassword
      username: $username
    ) {
      message
    }
  }
`;

export type ChangePasswordMutationVariables = {
  username: string;
  region: string;
  newPassword: string;
  previousPassword: string;
};

export type ChangePasswordMutationResponse = {
  changePassword: {
    message: string;
  };
};
